import { Routes } from '../api-routes'
import { BeneficiaryInsightsAssistemItems, Traceable } from '../dtos/assistant'
import { BeneficiaryDTO } from '../dtos/beneficiary'
import { StructuredDataValueDTO } from '../dtos/structured-data'
import {
  GenerateBeneficiaryProfileParams,
  GenerateBeneficiaryStructuredDataParams,
  GenerateReportParams,
  GenerationAnswerAboutBeneficiariesParams,
  GenerationAnswerAboutBeneficiaryParams,
} from '../events/generation'
import { getPath, setP } from './helpers'

export namespace BeneficiariesRoutes {
  export namespace one {
    export namespace askAbout {
      export function call(p = setP(['organizationId', 'beneficiaryId'])) {
        return getPath(p, { suffix: 'askAbout' })
      }
      export type Request = {
        params: GenerationAnswerAboutBeneficiaryParams
      }
      export type Response = { output: string } & Traceable
    }

    export namespace refreshProfile {
      export function call(p = setP(['organizationId', 'beneficiaryId'])) {
        return getPath(p, {
          suffix: 'generate/profile',
        })
      }
      export type Request = { params: GenerateBeneficiaryProfileParams }
      export type Response = { profile: string } & Traceable
    }

    export namespace refreshStructuredData {
      export function call(p = setP(['organizationId', 'beneficiaryId'])) {
        return getPath(p, {
          suffix: 'generate/structured-data',
        })
      }
      export type Request = { params: GenerateBeneficiaryStructuredDataParams }
      export type Response = {
        structuredData: StructuredDataValueDTO
      } & Traceable
    }

    export namespace generateReport {
      export function call(p = setP(['organizationId', 'beneficiaryId'])) {
        return getPath(p, {
          suffix: 'generate/report',
        })
      }
      export type Request = { params: GenerateReportParams }
      export type Response = {
        report: string
      } & Traceable
    }

    export namespace create {
      export function call(p = setP(['organizationId'])) {
        return getPath(p)
      }
      export type Request = {
        beneficiaryFields: Pick<BeneficiaryDTO, 'fullName' | 'profile'>
      }
      export type Response = { beneficiary: BeneficiaryDTO }
    }

    export namespace get {
      export function call(p = setP(['organizationId', 'beneficiaryId', 'asCaseWorkerId'])) {
        return getPath(p)
      }
      export type Response = { beneficiary: BeneficiaryDTO }
    }

    export namespace patch {
      export function call(p = setP(['organizationId', 'beneficiaryId'])) {
        return getPath(p)
      }
      export type Request = {
        beneficiaryFields: Partial<Pick<BeneficiaryDTO, 'fullName'>>
      }
      export type Response = { beneficiary: BeneficiaryDTO }
    }
  }

  export namespace askAbout {
    export function call(p = setP(['organizationId'])) {
      return getPath(p, { suffix: 'askAbout' })
    }
    export type Request = {
      params: GenerationAnswerAboutBeneficiariesParams
    }
    export type Response = {
      items: BeneficiaryInsightsAssistemItems
    }
  }

  export namespace get {
    export function call(p = setP(['organizationId', 'asCaseWorkerId'])) {
      return getPath(p, { suffix: Routes.Beneficiaries })
    }
    export type Response = { beneficiaries: BeneficiaryDTO[] }
  }
}
